import ApiService from "./ApiService"


export async function apiGetStoreList (data) {
    const { search } = data
    return ApiService.fetchData({
        url:  search ? search : `/stores`,
        method: 'get',
        data,
    })
}

export async function apiGetStoreTags () {
    return ApiService.fetchData({
        url: `/stores/tags`,
        method: 'get',
    })
}

export async function apiFetchStores (params = {}) {
    const {
        page = 1,
        pageSize = 100,
        sort = 'name',
        tags = [],
        tagMode = 'any',
        search,
        include,
        all,
        visible = 1,
        ...rest
    } = params

    const queryParams = {
        ...(all ? { all: true } : { 'page[number]': page, 'page[size]': pageSize }),
        ...rest,
    }

    if (sort) {
        queryParams.sort = sort
    }

    // Default: solo tiendas activas (visible=1). En tenants con tiendas legacy
    // que tienen visible=0 (ej Movistar PE: ~2k codigos numericos), la primera
    // pagina ordenada alfabeticamente puede quedar 100% invisibles, vaciando
    // el dropdown tras el filterVisibleStores del FE. Pasar visible: null para
    // incluir todas.
    if (visible !== null && visible !== undefined) {
        queryParams['filter[visible]'] = visible
    }

    if (Array.isArray(tags) ? tags.length > 0 : Boolean(tags)) {
        const normalizedTags = Array.isArray(tags) ? tags.join(',') : tags
        if (tagMode === 'all') {
            queryParams['filter[all_tags]'] = normalizedTags
        } else {
            queryParams['filter[tag]'] = normalizedTags
        }
    }

    if (search) {
        queryParams['filter[name]'] = search
    }

    if (include) {
        queryParams.include = include
    }

    return ApiService.fetchData({
        url: `/stores`,
        method: 'get',
        params: queryParams,
    })
}

export async function apiGetStoreListNew (params) {
    const { query } = params
    return ApiService.fetchData({
        url: query,
        method: 'get',
        //params
    })
}

export async function apiGetStoreById (id) {
    return ApiService.fetchData({
        url: `/stores/${id}`,
        method: 'get'
    })
}

export async function apiGetStoresCrudList (params) {
    const { query } = params

    const appendCacheBust = (rawUrl) => {
        if (!rawUrl || typeof rawUrl !== 'string') {
            return rawUrl
        }

        const normalizedUrl = rawUrl.replace(/([?&])_=\d+/g, '$1').replace(/[?&]$/, '')
        const hasQuery = normalizedUrl.includes('?')
        const separator = hasQuery ? '&' : '?'
        return `${normalizedUrl}${separator}_=${Date.now()}`
    }

    const cacheBustedUrl = appendCacheBust(query)

    const response = await ApiService.fetchData({
        url: cacheBustedUrl,
        method: 'get',
        //params
    })
    return response
}


export async function apiPostStores (data) {
    return ApiService.fetchData({
        url: `/stores`,
        method: 'post',
        data
    })
}

export async function apiPutStore (id, data) {
    return ApiService.fetchData({
        url: `/stores/${id}`,
        method: 'put',
        data
    })
}

export async function apiDeleteStore (id) {
    return ApiService.fetchData({
        url: `/stores/${id}`,
        method: 'delete',
    })
}

export async function apiStoreTimeline (params) {
    const { query } = params
    return ApiService.fetchData({
        url: query,
        method: 'get',
    })
}

export async function apiChangeSubscriptionStore(id){
    return ApiService.fetchData({
        url: `/subscribe/stores/${id}`,
        method: 'post'
    })
}

export async function apiSyncRecordsStore(id){
    return ApiService.fetchData({
        url: `/stores/${id}/sync_records`,
        method: 'post'
    })
}

export async function apiExportStoresCsv () {
    return ApiService.fetchData({
        url: `/stores/export`,
        method: 'get',
        responseType: 'blob',
    })
}



/* OLDS */

export async function apiGetScrumBoards (id) {
    return ApiService.fetchData({
        url:  `/stores/${id}`,
        method: 'get',
    })
}

export async function apiGetProjectDashboardData (params) {
    return ApiService.fetchData({
        url: '/project/dashboard',
        method: 'get',
        params
    })
}


export async function apiPutProjectList (data) {
    return ApiService.fetchData({
        url: '/project/list/add',
        method: 'put',
        data
    })
}

/* export async function apiGetScrumBoards () {
    return ApiService.fetchData({
        url: '/project/scrum-board/boards',
        method: 'post',
    })
} */

export async function apiGetScrumBoardtMembers () {
    return ApiService.fetchData({
        url: '/project/scrum-board/members',
        method: 'post',
    })
}

export async function apiGetScrumBoardtTicketDetail (params) {
    return ApiService.fetchData({
        url: '/project/scrum-board/tickets/detail',
        method: 'get',
        params
    })
}
